import {Injectable} from '@angular/core';
import {MailerMessage} from './mailer.service';
import * as moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class PhysicianEmailAddrService {
  setAddresses(message: MailerMessage, doctor, staff, ptm, pdm,
               practiceStatus, relationshipStatus, physicianStatusType,
               physicianAccountSubtype, openingDate
              ) {
    // To
    if (!message.To) {
      message.To = [];
    }
    if (doctor) {
      message.To.push(doctor);
    }
    if (staff) {
      message.To.push(staff);
    }
    if (relationshipStatus === 'MDVIP Employed Affiliate') {
      message.To.push('OwnedPracticeOps@mdvip.com');
    }
    if (physicianStatusType && physicianStatusType.toLowerCase() === 'separation in progress') {
      message.To.push('SuccessionEvents@mdvip.com');
    }
    // Cc
    if (!message.Cc) {
      message.Cc = [];
    }

    let isFullBuildUnderSix = false;
    let isFullBuildUnderFive = false
    if (physicianAccountSubtype === 'Full Build Physician') {
      if (openingDate) {
        const openingMoment = moment(openingDate);
        if (moment().isBefore(openingMoment.clone().add(6, 'months'))) {
          isFullBuildUnderSix = true;
        }
        if (moment().isBefore(openingMoment.clone().add(5, 'months'))) {
          isFullBuildUnderFive = true;
        }
      }
    }

    // message.Cc.push('pdmadmin@mdvip.com'); // commented 6/10/2025
    if (ptm && (practiceStatus.toLowerCase().replace(/-/g, ' ') === 'transition' || practiceStatus.toLowerCase().replace(/-/g, ' ') === 'pre open' || isFullBuildUnderSix)) {
      message.Cc.push(ptm);
    }
    if (pdm && !isFullBuildUnderFive && (practiceStatus.toLowerCase().replace(/-/g, ' ') === 'pre open' || practiceStatus.toLowerCase().replace(/-/g, ' ') === 'post open')) {
      message.Cc.push(pdm);
    }
    // Bcc
    if (!message.Bcc) {
      message.Bcc = [];
    }
    message.Bcc.push('marketingsupportsite@mdvip.com');
  }
}
